

export const linkStatus ={
    waitOrder : 1,
    successComplete : 2,
    emptyStatus : 3,
    expire : 4
}